export default __webpack_public_path__ + "images/629772b7cf997f6823f52b64e879a88d-1_mobile_659x494.jpg";